import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import { DRAW_MODES } from '@pixi/constants';
var BatchDrawCall = /*#__PURE__*/_createClass(function BatchDrawCall() {
  _classCallCheck(this, BatchDrawCall);
  this.texArray = null;
  this.blend = 0;
  this.type = DRAW_MODES.TRIANGLES;
  this.start = 0;
  this.size = 0;
  this.data = null;
});
export { BatchDrawCall };